export type ReadFileOptions = {
  url: string;
  maxBytes?: number;
};

type FileDataBase = {
  content: string;
  contentType: string;
};

export type FileData = FileDataBase &
  (
    | {
        /**
         * This is only available post versions:
         * - iOS: 0.4.5 (1)
         * - Android: 0.1.24 (39)
         */
        name: string;

        /**
         * This is only available post versions:
         * - iOS: 0.4.5 (1)
         * - Android: 0.1.24 (39)
         */
        size: number;
      }
    | Record<string, never>
  );

export type UploadFileOptions = {
  uploadUrl: string;
  fileUri: string;
  headers: Record<string, string>;
  method: string;
  chunkSize?: number | null;
  chunkIndex?: number | null;
};

export enum UploadStatus {
  IN_PROGRESS,
  COMPLETED,
  ERROR,
}

export type UploadProgress = {
  /**
   * Status of the upload
   */
  status: UploadStatus;
  /**
   * Progress from 0-100
   */
  progress: number;
  /**
   * Upload speed in MB
   */
  uploadSpeed: number;
  /**
   * An error message or complete message.
   */
  message: string;
  /**
   * The response headers from the upload.
   */
  responseHeaders?: Record<string, string>;
};

export interface ReadFilePlugin {
  readFile(options: ReadFileOptions): Promise<FileData>;
  uploadFile(
    options: UploadFileOptions,
    callback: (progress: UploadProgress | null, err?: unknown) => void,
  ): Promise<string>;
}
